module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-tag-input",
    class: {
      focus: _vm.focused
    },
    on: {
      "click": function($event) {
        _vm.$refs.input.focus()
      }
    }
  }, [_vm._l((_vm.tags), function(t, idx) {
    return _c('label', {
      key: idx,
      staticClass: "label label-primary"
    }, [_vm._v("\n    " + _vm._s(t) + "\n    "), _c('i', {
      staticClass: "fa fa-remove",
      on: {
        "click": function($event) {
          _vm.removeTag(idx)
        }
      }
    })])
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputTag),
      expression: "inputTag"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.inputTag)
    },
    on: {
      "blur": function($event) {
        _vm.focused = false
      },
      "focus": function($event) {
        _vm.focused = true
      },
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.addTag($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputTag = $event.target.value
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41b7e112","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tag-input/tag-input.vue
// module id = 55
// module chunks = 0